import { render, staticRenderFns } from "./BrowserMessage.vue?vue&type=template&id=f4adcef0&scoped=true&"
import script from "./BrowserMessage.vue?vue&type=script&lang=js&"
export * from "./BrowserMessage.vue?vue&type=script&lang=js&"
import style0 from "./BrowserMessage.vue?vue&type=style&index=0&id=f4adcef0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4adcef0",
  null
  
)

export default component.exports